import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Intercepteur : rafraîchit automatiquement l'access_token sur 401 et retente la requête
let refreshing = null;
api.interceptors.response.use(
  (resp) => resp,
  async (err) => {
    const original = err?.config;
    const status = err?.response?.status;
    // On ne retente pas si : pas de config, pas un 401, déjà retenté, ou si c'est l'endpoint refresh/login lui-même
    if (
      !original ||
      status !== 401 ||
      original._retry ||
      /\/auth\/(refresh|login|logout|register|demo-login)/.test(original.url || "")
    ) {
      return Promise.reject(err);
    }
    original._retry = true;
    try {
      if (!refreshing) refreshing = api.post("/auth/refresh");
      await refreshing;
      refreshing = null;
      return api(original);
    } catch (e) {
      refreshing = null;
      return Promise.reject(err);
    }
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" · ");
  }
  if (detail?.msg) return detail.msg;
  return String(detail);
}
